import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import TextArea from "../../components/forms-fields/TextArea";
import Input from "../../components/forms-fields/Input";
import { addMedicationStock } from "../../schemas";
import { useFormik } from "formik";
import Select from 'react-select'
import moment from 'moment';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { UPDTE_MEDICINE_STOCK__INVENTORY_URL } from "../../env";
import {
  updateRecords,
  catchAsync,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
} from "../../helper/helper";
import MedicineListDetail from "../../components/forms-fields/MedicineListDetail";
// import HealthCategories from "./HealthCategories";

function EditMedicineStock({ userId, subModalEditMedication, medicationStockDetail }) {
  // console.log("🚀 ~ EditMedicineStock ~ medicationStockDetail:", medicationStockDetail)
  // console.log("🚀 ~ file: EditMedicineStock.jsx:22 ~ EditMedicineStock ~ medicationStockDetail:", medicationStockDetail)
  // const [userId, setUserId] = useState(userDataId);
  const handleShowHideModal = () => {
    subModalEditMedication((prevShow) => !prevShow);
  };
  const [isStaffId, setIsStaffId] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [isSuFormData, setIsSuFormData] = useState(false);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [isToastEditMedicine, setIsToastEditMedicine] = useState(false);
  const [parentSubCatValidationStatus, setParentSubCatValidationStatus] = useState(false);
  const [selectedMedication, setSelectedMedication] = useState(null);
  const [medicationData, setMedicationData] = useState([]);
  const [medicationFilteredData, setMedicationFilteredData] = useState([]);

  const [suFormData, setSuFormData] = useState({

    medicationId: medicationStockDetail?._id,
    user: medicationStockDetail?.user,
    medicationName: medicationStockDetail?.medicationName,
    user: userId,
    inventory: medicationStockDetail?.inventory,
    unitType: medicationStockDetail?.unitType,
    strength: medicationStockDetail?.strength,
    medicationSafetyTime: medicationStockDetail?.medicationSafetyTime,
    medicineType: medicationStockDetail?.medicineType,
    sideEffect: medicationStockDetail?.sideEffect,


  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldTouched,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: addMedicationStock,
    onSubmit: async (values) => {
      try {

        setIsSuFormData(false);
        setIsSubmitButtonClicked(true);
        await postEditMedicineFormData(values);
      } catch (error) {

      }
    },
  });

  const processPostRecords = (method, data) => {

    if (data?.status !== isSuccess) {
      setIsToastEditMedicine(true);
      toastErrorMessages(toast.error, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);
      handleShowHideModal();
    } else if (
      method === "postEditMedicineFormData" &&
      data?.status === isSuccess
    ) {
      setIsToastEditMedicine(true);
      toastSuccessMessages(toast.success, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);
      setTimeout(() => {
        handleShowHideModal();
      }, 2000);
    }
  };

  const postEditMedicineFormData = catchAsync(async (req, res) => {
    // console.log(values);
    const response = await updateRecords(UPDTE_MEDICINE_STOCK__INVENTORY_URL, values);
    processPostRecords("postEditMedicineFormData", response);
    setIsSubmitButtonClicked(false);
  });



  const handleInputChangePrevFields = (e) => {
    if (e && e?.value !== undefined) {
      setFieldValue("medicationType", e.value);
    }
    else {
      handleChange(e);
      handleBlur(e);
    }
  };


  const options = [
    { label: 'Liquid', value: 'Liquid' },
    { label: 'Tablet', value: 'Tablet' },
    { label: 'Capsules', value: 'Capsules' },
    { label: 'Drops', value: 'Drops' },
    { label: 'Suppositories', value: 'Suppositories' },
    { label: 'Inhalers', value: 'Inhalers' },
    { label: 'Injections', value: 'Injections' },
    // Add more options as needed
  ];


  const handleMedicationSelect = (value) => {
    setSelectedMedication(value);
  };

  const handleMedicationDataChange = (data) => {
    setMedicationData(data);
  };
  useEffect(() => {
    setMedicationFilteredData(medicationData?.filter((item) => item?._id === selectedMedication));
  }, [selectedMedication])

  useEffect(() => {
    if (medicationFilteredData && medicationFilteredData.length > 0) {
      setValues(prevValues => ({
        ...prevValues,
      }));
    }
  }, [medicationData, medicationFilteredData]);
  return (
    <>
      <div className="incidents consentCapacityAddNew">
        <form onSubmit={handleSubmit}>
          <div className="formBlockContent">
            <div className="row">
              <div className="col-md-12">
                <Input
                  type="text"
                  id=""
                  name="medicationName"
                  value={values?.medicationName}
                  onChange={handleInputChangePrevFields}
                  onBlur={handleBlur}
                  labelText="Medicine Name"
                  disabledStatus={true}
                />
              </div>

              <div className="col-md-6">
                <Input
                  type="text"
                  id=""
                  name="unitType"
                  value={values?.unitType}
                  onChange={handleInputChangePrevFields}
                  onBlur={handleBlur}
                  labelText="Unit Type"
                  disabledStatus={true}
                />
              </div>

              <div className="col-md-6">
                <Input
                  type="text"
                  id=""
                  name="strength"
                  value={values?.strength}
                  onChange={handleInputChangePrevFields}
                  onBlur={handleBlur}
                  labelText="Strength"
                  disabledStatus={true}

                />
              </div>
              <div className="col-md-12">
                <Input
                  type="text"
                  id=""
                  name="medicationSafetyTime"
                  value={values?.medicationSafetyTime}
                  onChange={handleInputChangePrevFields}
                  onBlur={handleBlur}
                  labelText="Safety Time (Mins)"
                  disabledStatus={true}

                />
              </div>
              <div className="col-md-12">
                <Input
                  type="text"
                  id=""
                  name="medicineType"
                  value={values?.medicineType}
                  onChange={handleInputChangePrevFields}
                  onBlur={handleBlur}
                  labelText="Medicine Type"
                  disabledStatus={true}

                />
              </div>
              <div className="col-md-12">
                <Input
                  type="text"
                  id=""
                  name="sideEffect"
                  value={values?.sideEffect}
                  onChange={handleInputChangePrevFields}
                  onBlur={handleBlur}
                  labelText="Side Effects"
                  disabledStatus={true}

                />
              </div>

              {/* <div className="col-md-12">
                <Input
                  type="text"
                  id=""
                  name="medicationName"
                  value={values?.medicationName}
                  onChange={handleInputChangePrevFields}
                  onBlur={handleBlur}
                  labelText="Medicine Name"
                  customError={
                    errors.medicationName && touched.medicationName
                  }
                  errorMessage={errors.medicationName}
                  errorClass={
                    errors.medicationName && touched.medicationName
                  }
                  requiredStar={true}
                />
              </div> */}
              <div className="col-md-12">
                <Input
                  type="number"
                  id="inventory"
                  name="inventory"
                  value={values?.inventory}
                  onChange={handleInputChangePrevFields}
                  onBlur={handleBlur}
                  labelText="Medicine Quantity"
                  marginBottom={true}
                  customError={
                    errors.inventory && touched.inventory
                  }
                  errorMessage={errors.inventory}
                  errorClass={
                    errors.inventory && touched.inventory
                  }
                  requiredStar={true}
                />
              </div>
            </div>
          </div>

          <div className="formActionButtons">
            <span
              onClick={subModalEditMedication}
              className="btn btn-sm btn-outline-primary"
            >
              Close
            </span>
            {isSubmitButtonClicked ? (
              <Button
                onClick={subModalEditMedication}
                className="btn-sm"
                variant="primary"
                disabled
              >
                Loading...
              </Button>
            ) : (
              <Button className="btn-sm" variant="primary" type="submit">
                Save
              </Button>
            )}
          </div>
        </form>
      </div>
      {isToastEditMedicine && <ToastContainer />}
    </>
  );
}

export default EditMedicineStock;